module.exports = __webpack_public_path__ + "img/lb.ed7ed52d.svg";